'use client'; // 声明为客户端组件
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCk1d13WpstAtqEm8klCQcsZ52X_whGU2A",
  authDomain: "askpaul-2d6ae.firebaseapp.com",
  projectId: "askpaul-2d6ae",
  storageBucket: "askpaul-2d6ae.firebasestorage.app",
  messagingSenderId: "812002168219",
  appId: "1:812002168219:web:76aad749b77798a430253e",
  measurementId: "G-DCN7T1PBH9"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// export const analytics = getAnalytics(app);
let analytics: any = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
  // 如果不支持，analytics 将保持为 null
});
export { analytics };

export { getAuth, GoogleAuthProvider, signInWithPopup };
